export default {
  product: (state) => {
    return state.product;
  },
};
